import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Row, Col } from "reactstrap";
import ModalConfirmation from "../../../components/Modal/ModalConfirmation";

import { TextInput } from "../../../components/GenericInputsFormik/index";

import { useEffect } from "react";
import { peticionesReceiver } from "../../../helpers/peticionesReceiver";
import { toast } from "react-toastify";
import Notification from "../../../components/Notification/Notification";
import Loader from "../../../components/Loader/Loader";

const FormInstituciones = ({
  permissions,
  setRefreshP,
  cct,
  setCct,
  setCollapse,
}) => {
  const [modalConfirmation, setModalConfirmation] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const API = peticionesReceiver();

  const FormSchema = Yup.object().shape({
    nameCCT: Yup.string().required("Ingrese el nombre de la institución"),
  });

  const { handleSubmit, values, errors, setFieldValue, touched, handleBlur } =
    useFormik({
      initialValues: {
        idPerceptionExtra: "",
        namePerceptionExtra: "",
        idUnder: "",
        daysPay: "",
        startDate: "",
        endDate: "",
      },
      onSubmit: () => {
        setModalConfirmation(true);
      },
      validationSchema: FormSchema,
      enableReinitialize: true,
    });

  const onChange = (e) => {
    const { name, value } = e.target;
    setFieldValue(name, value);
  };

  const saveCct = async () => {
    const data =
      !isEdit === true
        ? {
            action: "insert",
            table: "cct",
            rows: {
              nameCCT: values.nameCCT,
            },
          }
        : {
            action: "update",
            table: "cct",
            rows: {
              nameCCT: values.nameCCT,
            },
            condition: {
              idCCT: values.idCCT,
            },
          };
    const res = await API.peticion(data);
    if (res.status === 200 && res.data.status === "success") {
      toast(
        <Notification
          type={"agrega_exito"}
          backMessage={res.data.message}
          withIcon
        />
      );
      setCollapse("home");
      setCct(res.data.data[0]);
      setFieldValue("idPerceptionExtra", res.data.data[0].idPerceptionExtra);
      setRefreshP(true);
    } else {
      toast(
        <Notification
          type={"agrega_error"}
          backMessage={res.data.message}
          withIcon
        />
      );
    }
  };

  useEffect(() => {
    if (cct && cct !== "") {
      setDataForEdit();
    }
  }, []);

  const setDataForEdit = () => {
    setIsEdit(true);
    setFieldValue("idCCT", cct.idCCT);
    setFieldValue("nameCCT", cct.nameCCT);
  };

  return (
    <div>
      {true ? (
        <>
          <form onSubmit={handleSubmit}>
            <div className="text-center">
              <h2>Nueva clave del centro de trabajo</h2>
            </div>

            <Row className="d-flex justify-content-around ">
              <Col xs={12} lg={5}>
                <TextInput
                  label="Nombre de la clave del centro de trabajo"
                  inputType="text"
                  inputName="nameCCT"
                  isRequired
                  onChangeMethod={onChange}
                  onBlurMethod={handleBlur}
                  value={values.nameCCT}
                  touched={touched.nameCCT}
                  errors={errors.nameCCT}
                />
              </Col>
            </Row>

            <div className="d-flex justify-content-around">
              {isEdit
                ? permissions.UPD && (
                    <div>
                      <Button type="submit" color="success">
                        Editar
                      </Button>
                    </div>
                  )
                : permissions.INS && (
                    <div>
                      <Button type="submit" color="success">
                        Agregar
                      </Button>
                    </div>
                  )}
            </div>
          </form>

          <ModalConfirmation
            modalTitle={isEdit ? "Editar" : "Crear"}
            modal={modalConfirmation}
            setModal={setModalConfirmation}
            crear={saveCct}
            editar={saveCct}
            isEdit={false}
            values={values}
          >
            <div className="text-center">
              Esta seguro de continuar con el registro
            </div>
          </ModalConfirmation>
        </>
      ) : (
        <div>
          <Loader />
        </div>
      )}
    </div>
  );
};

export default FormInstituciones;
